import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

import Chip from 'Chip';

const Thank = ({ thankTitleImage }) => {
    return (
        <div className={styles.thank}>
            <Chip id="260727" title="特别鸣谢专区标题图" groupName="中国力量" type="struct">
                <div className={styles.thankTitle}>
                    <img src={thankTitleImage} />
                </div>
            </Chip>
            <div className={styles.thankBox}>
                <img src="https://x0.ifengimg.com/ucms/2023_38/A7A720E0D69578396B73F55BEC088C15FAB5B241_size164_w632_h194.png" />
            </div>
        </div>
    );
};

Thank.propTypes = {
    thankTitleImage: PropTypes.string,
};

export default errorBoundary(Thank);
